<div class="row page-title">
  <app-back-button [title]="localizationConstants.ADMIN_BACK_BUTTON_TITLE"></app-back-button>
  <span>{{ localizationConstants.REQUESTED_SERVICE_LIST_PAGE_TITLE | translate }}</span>
</div>

<div *ngIf="famCodes?.length">
  <div class="row">
    <div class="col c-details">
      <mat-card
        appearance="outlined"
        class="requested-service-list-note-box">
        <mat-card-header class="requested-service-list-note-header">{{
          localizationConstants.REQUESTED_SERVICE_LIST_NOTE | translate
        }}</mat-card-header>
        <mat-card-content>{{
          localizationConstants.REQUESTED_SERVICE_LIST_NOTE_TEXT | translate
        }}</mat-card-content>
      </mat-card>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="o-grid">
        <div class="o-grid__item col-12 col-md-3 col-sm-5 u-p-bottom-only">
          <label
            class="c-form-label"
            for="role"
            >{{ localizationConstants.REQUESTED_SERVICE_LIST_FAM_CODE | translate }}</label
          >

          <mat-select
            [(ngModel)]="selectedFamCode"
            id="fam"
            name="fam"
            class="c-user-menu__select c-select c-select--lg"
            (ngModelChange)="loadRequestedServiceList()"
            required>
            <mat-option
              *ngFor="let fam of famCodes"
              [value]="fam">
              {{ fam }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <div class="o-grid">
        <div
          class="o-grid__item col-6 col-sm-4 u-p-bottom-only"
          *ngIf="selectedFamCode">
          <label
            class="c-form-label"
            for="role"
            >{{ localizationConstants.REQUESTED_SERVICE_LIST_VALUE_COLUMN_NAME | translate }}</label
          >

          <input
            [(ngModel)]="currentValue"
            (ngModelChange)="onValueChange()"
            name="currentValue"
            type="text"
            class="c-input c-input--gamma requested-service-input" />
        </div>

        <div
          class="o-grid__item col-6 col-sm-4 u-p-bottom-only"
          *ngIf="selectedFamCode">
          <label
            class="c-form-label"
            for="role"
            >{{
              localizationConstants.REQUESTED_SERVICE_LIST_DISPLAY_VALUE_COLUMN_NAME | translate
            }}</label
          >

          <input
            [(ngModel)]="currentDisplayValue"
            name="currentDisplayValue"
            type="text"
            class="c-input c-input--gamma requested-service-input" />
        </div>

        <div
          class="o-grid__item col-6 col-sm-2 u-p-bottom-only align-self-end"
          *ngIf="selectedFamCode">
          <button
            (click)="onServiceRequestAdd()"
            type="button"
            class="button button-primary button-block requested-service-list-btn-add">
            {{ "button.add" | translate }}
          </button>
        </div>

        <div class="col-sm-1"></div>
      </div>
    </div>
  </div>
</div>

<div
  [hidden]="!selectedFamCode"
  class="row">
  <div class="col">
    <div class="u-scroll--horizontal">
      <div class="col">
        <table
          mat-table
          matSort
          [dataSource]="dataSource"
          class="c-table">
          <ng-container matColumnDef="value">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef
              class="c-table__column-title">
              {{ localizationConstants.REQUESTED_SERVICE_LIST_VALUE_COLUMN_NAME | translate }}
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              width="35%">
              {{ row.value }}
            </td>
          </ng-container>

          <ng-container matColumnDef="displayValue">
            <th
              mat-header-cell
              mat-sort-header
              *matHeaderCellDef>
              {{
                localizationConstants.REQUESTED_SERVICE_LIST_DISPLAY_VALUE_COLUMN_NAME | translate
              }}
            </th>
            <td
              mat-cell
              *matCellDef="let row"
              width="35%">
              {{ row.displayValue }}
            </td>
          </ng-container>

          <ng-container matColumnDef="action1">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="c-table__column-title"></th>
            <td
              mat-cell
              *matCellDef="let row"
              width="10%">
              <button
                type="button"
                class="button--sm button-secondary button-block"
                (click)="onServiceRequestDelete(row)">
                <span>{{ localizationConstants.BUTTON_DELETE | translate }}</span>
              </button>
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="['value', 'displayValue', 'action1']"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: ['value', 'displayValue', 'action1']"
            class="c-table__row"></tr>
        </table>
      </div>
    </div>
    <div class="c-pagination--desktop">
      <div class="col-12">
        <mat-paginator
          [showFirstLastButtons]="true"
          [pageSize]="pageSize"
          [pageSizeOptions]="[10, 50, 100]"></mat-paginator>
      </div>
    </div>
  </div>
</div>
